import { useQuery } from 'react-query'
import useAxios from './useAxios'

const useAtelier = (filterId) => {
	const { getAteliers } = useAxios()
	const { isLoading, data: ateliers } = useQuery(
		(filterId && `ateliers-${filterId}`) || 'ateliers',
		() => getAteliers(filterId),
	)

	if (isLoading) return { isLoading }

	return {
		isLoading,
		ateliers,
	}
}

export default useAtelier
